import { z } from 'zod';
import { idValidator } from '@/schemas/common/validators';

// Request schema for bulk auto-tag
export const BulkAutoTagRequestSchema = z.object({
  listingIds: z.array(idValidator).min(1, 'At least one listing ID is required').max(100, 'Maximum 100 listings per request'),
});

export type BulkAutoTagRequest = z.infer<typeof BulkAutoTagRequestSchema>;

// Response schema for bulk auto-tag
export const BulkAutoTagResponseSchema = z.discriminatedUnion('success', [
  z.object({
    success: z.literal(true),
    taggedCount: z.number(),
    skippedCount: z.number(),
    totalRequested: z.number(),
    results: z.record(z.string(), z.array(z.string())),
  }),
  z.object({
    success: z.literal(false),
    error: z.string(),
    details: z.string().optional(),
  }),
]);

export type BulkAutoTagResponse = z.infer<typeof BulkAutoTagResponseSchema>;
